import { ColoredIcon } from "@msuite/ui/icons";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface TicketTypeSelectItemProps {
	ticketType: Tables<"ticketTypes"> | undefined;
}

export function TicketTypeSelectItem({ ticketType }: TicketTypeSelectItemProps) {
	/** Guard */
	if (!ticketType) return null;

	/** Render */
	return (
		<div className="h-stack">
			<ColoredIcon
				iconName={ticketType.icon}
				color={ticketType.color}
			/>
			<div>{ticketType.name}</div>
		</div>
	);
}
